module.exports = __webpack_public_path__ + "img/2.5b06c5e5.png";